import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../shared/Button"
import { showModal } from "../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../hooks/useScrollLock"
import { useEffect } from "react"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: auto;
        height: auto;
        padding: 50px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img{
            width: 500px;
            height: auto;
            max-height: 750px;
            margin-bottom: 20px;
        }
    }

`
    
const ImageModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const {userDocImage} = useSelector(state => state.user)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    if(!userDocImage) {
        return null
    }
  return (
    <Container onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <img src={userDocImage} alt="" />
            <Button text={"Kapat"} handleClick={() => dispatch(showModal(null))} background="#E85446" width="180px" color={"#fff"} />
        </div>
    </Container>
  )
}
 
export default ImageModal